import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'; // Assuming you've configured Tailwind in this file
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
